module.exports = __webpack_public_path__ + "img/cancun-bay-room-2.1d10cd64.jpg";